import React from 'react'
import { useFormContext } from 'react-hook-form'
import { useTranslation } from 'react-i18next'

import {
  buildSurveyFilterTextGroups,
  dataDisplayTypeLabelI18nKeyMap,
  type FigureInfo,
  findByPath,
} from '~/utils'

import { useBrandAccountId } from '../hooks/useBrandAccountId'
import { useSurvey } from '../hooks/useSurvey'
import { type InputValues, pathKey } from '../utils'

export const useFigureInfo = () => {
  const { t } = useTranslation()
  const brandAccountId = useBrandAccountId()

  const survey = useSurvey()
  const { watch } = useFormContext<InputValues>()
  const [brandGroupId, brandId, dataDisplayType, filterGroups] = watch([
    'brandGroupId',
    'brandId',
    'dataDisplayType',
    'surveyFilter.filterGroups',
  ])
  const brandGroup = React.useMemo(
    () => findByPath(survey?.brandGroups ?? [], 'id', brandGroupId),
    [brandGroupId, survey?.brandGroups],
  )
  const brand = React.useMemo(
    () => findByPath(brandGroup?.brands ?? [], 'id', brandId),
    [brandId, brandGroup?.brands],
  )

  return React.useMemo<FigureInfo>(
    () => ({
      brandAccountId,
      pathKey,
      survey: survey?.title,
      brandGroup: brandGroup?.name,
      brand: brand?.name,
      dataDisplayType: dataDisplayTypeLabelI18nKeyMap[dataDisplayType],
      surveyFilter: buildSurveyFilterTextGroups({
        filterGroups,
        questions: survey?.questions ?? [],
        customerAttributeGroups: survey?.customerAttributeGroups ?? [],
        brandGroups: survey?.brandGroups ?? [],
        t,
      }),
    }),
    [
      brand?.name,
      brandAccountId,
      brandGroup?.name,
      dataDisplayType,
      filterGroups,
      survey?.brandGroups,
      survey?.customerAttributeGroups,
      survey?.questions,
      survey?.title,
      t,
    ],
  )
}
